export const ADD_EMPLOYEES_TABLE_TEST_IDS = {
  TABLE: 'add-employees-table-test-id',
  TABLE_ROW: 'add-employees-table-row-test-id',
};

export const TABLE_MANAGEMENT_PANEL_TEST_IDS = {
  COLLECTION_MANAGEMENT_HEADER: 'collection-management-header-test-id',
  ADD_EMPLOYEES_DROPDOWN: 'add-employees-dropdown-test-id',
  EMPLOYEES_STATUS_FILTER_DROPDOWN: 'employees-status-filter-dropdown-test-id',
  SUB_PROGRESS_FILTER_DROPDOWN: 'sub-progress-filter-dropdown-test-id',
};
